export class Tariffa {
  id: number;
  denominazione: string;
  prezzo: number
}
